import React, { useEffect } from "react";
import ResearchSection from "../sections/ResearchSection";

const ResearchPage = () => {
	useEffect(() => { window.scrollTo(0, 0); }, []);

	return (
		<div className="page-spacer">
			<div className="page-grid-bg" />
			<div className="page-orb-1" />
			<div className="page-orb-2" />
			<div className="page-orb-3" />
			<ResearchSection />
		</div>
	);
};

export default ResearchPage;
